module.exports = __webpack_public_path__ + "static/npckc2-441b59f61cc669091d861fb1180937b8.png";